import MarkdownIt from "markdown-it";
import { type PositionQualificationChatResponse } from "../api";
import { Utility } from "./utility";

const md = new MarkdownIt();

export interface PositionQualificationChat extends PositionQualificationChatResponse {}

export class PositionQualificationChat extends Utility<PositionQualificationChat> {
  constructor(init?: Partial<PositionQualificationChatResponse>) {
    super();
    Object.assign(this, init);
  }

  get formattedMessage() {
    try {
      const message = JSON.parse(this.message);

      let formattedMessage = "";
      if (message["required_qualifications"])
        formattedMessage += "**Required Qualifications**:\n";

      message["required_qualifications"]
        .sort(
          (a: { index: number }, b: { index: number }) =>
            a["index"] - b["index"],
        )
        .forEach(
          (qualification: {
            index: number;
            assessment_result: string;
            recommended_solution: string;
          }) => {
            formattedMessage += `- Required Qualification #${qualification["index"]}\n`;
            formattedMessage += `  - *Assessment*: ${qualification["assessment_result"]}\n`;
            formattedMessage += `  - *Recommendation*: ${qualification["recommended_solution"]}\n`;
          },
        );

      if (message["preferred_qualifications"])
        formattedMessage += "\n**Preferred Qualifications**:\n";
      message["preferred_qualifications"]
        .sort(
          (a: { index: number }, b: { index: number }) =>
            a["index"] - b["index"],
        )
        .forEach(
          (qualification: {
            index: number;
            assessment_result: string;
            recommended_solution: string;
          }) => {
            formattedMessage += `- Preferred Qualification #${qualification["index"]}\n`;
            formattedMessage += `  - *Assessment*: ${qualification["assessment_result"]}\n`;
            formattedMessage += `  - *Recommendation*: ${qualification["recommended_solution"]}\n`;
          },
        );

      return md.render(formattedMessage).replace(/\n/g, "");
    } catch (error) {
      return this.message;
    }
  }
}
